<template>
  <div class="exams-status-grid">
    <modal
      ref="examsStatusGridModal"
      ref-name="examsStatusGridModal"
      title="Entenda o que é cada status da rastreabilidade"
      template="question"
      :icon-enabled="false"
      close-button-enabled
      hide-second-button
      hide-first-button
    >
      <div class="exams-status-grid-container">
        <table class="exams-status-grid-table">
          <colgroup>
            <col class="exams-status-grid-table-cell-color">

            <col class="exams-status-grid-table-cell-status">

            <col class="exams-status-grid-table-cell-description">
          </colgroup>

          <tbody class="exams-status-grid-table-body">
            <tr
              v-for="status in statusList"
              :key="status.key"
              class="exams-status-grid-table-body-row"
            >
              <td class="exams-status-grid-table-body-cell">
                <div
                  class="exams-status-grid-color-circle"
                  :style="{
                    backgroundColor: status.color
                  }"
                />
              </td>

              <td class="exams-status-grid-table-body-cell">
                {{ status.label }}
              </td>

              <td class="exams-status-grid-table-body-cell">
                {{ status.description }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </modal>

    <button
      type="button"
      class="exams-status-grid-button"
      @click="handleOpenModal"
    >
      <svg-loader
        src="/static/images/icon-info-small.svg"
        class="exams-status-grid-button-icon"
      />

      Status de rastreabilidade
    </button>
  </div>
</template>

<script>
import { TraceabilityStatus } from '@/enums'

export default {
  name: 'ExamsStatusGrid',
  data() {
    return {
      statusList: [
        {
          key: 'AGUARDANDO_RETIRADA',
          label: 'Aguardando retirada',
          color: '#76D692',
          description: 'A amostra foi gerada e o lote está pronto para ser retirado pela '
        },
        {
          key: 'EM_TRANSITO',
          label: 'Em trânsito',
          color: '#76D692',
          description: 'O lote está em trânsito, a caminho do nosso NTO.'
        },
        {
          key: 'TRIAGEM',
          label:'Aguardando recebimento no NTO',
          color: '#76D692',
          description: 'Lote entregue ao NTO. Aguardando recebimento das amostras na área técnica.'
        },
        {
          key: 'EM_EXECUCAO',
          label: 'Em execução',
          color: '#76D692',
          description: 'O exame entrou em execução.'
        },
        {
          key: 'EM_LIBERACAO',
          label: 'Aguardando liberação',
          color: '#76D692',
          description: 'O exame foi executado e está aguardando liberação técnica.'
        },
        {
          key: 'LAUDO_LIBERADO',
          label: 'Laudo liberado',
          color: '#32A454',
          description: 'O exame foi executado e seu resultado está disponível.'
        },
        {
          key: 'behindSchedule',
          label: 'Atrasado',
          color: '#F5A623',
          description: 'O exame está na fila para ser executado.'
        },
        {
          key: 'NAO_RECEBIDA',
          label: 'Não recebida',
          color: '#87003F',
          description: 'O lote chegou ao NTO, mas a amostra não constava fisicamente no mesmo.'
        },
        {
          key: 'NAO_ENVIADA',
          label: 'Não enviada',
          color: '#87003F',
          description: 'A amostra não foi retirada ou entregue para a logística.'
        },
        {
          key: 'NAO_RASTREADO',
          label: 'Não rastreada',
          color: '#87003F',
          description: 'A amostra foi retirada mas não foi entregue ao NTO.'
        },
        {
          key: 'CANCELADO',
          label: 'Cancelado',
          color: '#919191',
          description: 'Amostra cancelada pela unidade de produção.'
        },
        {
          key: 'RECOLETADO',
          label: 'Recoleta solicitada',
          color: '#F5A623',
          description: 'Solicitada uma nova coleta.'
        },
        {
          key: 'AMOSTRA_DESCARTADA',
          label: 'Amostra descartada',
          color: '#919191',
          description: 'Amostra descartada pela unidade de produção após finalização do tempo de armazenamento.'
        },
      ]
    }
  },
  methods: {
    handleOpenModal() {
      this.$refs.examsStatusGridModal.open()
    }
  }
}
</script>

<style lang="scss" scoped>
.exams-status-grid {
  font-family: 'Exo 2';

  &-container {
    display: flex;
    background-color: #EEEEEE;
    border-radius: 0.5rem;
    padding: 0.5rem;
  }

  &-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;

    &-header {
      &-cell {
        text-align: left;
        padding: 0.5rem 1rem;
      }
    }

    &-body {
      &-cell {
        padding: 0.5rem 1rem;
      }
    }

    &-cell {
      &-color {
        width: 48px;
      }

      &-status {
        width: 200px;
      }
    }
  }

  &-color-circle {
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
  }

  &-button {
    font-weight: 400;
    font-size: 0.75rem;
    color: #818181;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background-color: transparent;
    padding: 0;
    height: auto;

    &-icon {
      width: 1rem;
      height: 1rem;
      min-width: auto;
      min-height: auto;
    }
  }
}

::v-deep(.standard-modal__container-cta) {
  display: none;
}
</style>
